export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImUxMjJlY2E3LWIwODUtNDllNi05MzhjLWRmMDNjYzM0MWUyNSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.bEyy0ldl2lzDr6mhz7HHsBqXnrsB252dsuunFbjIN/HO2iJBTCeF9eCY1xUGoROH35i7tu1ltAkFp04ces5vbTtWRl6r/K7LDyCzT25kDUtM0wO+Ptob+1OsCaYRtAyBhy7+3g==';
